document.addEventListener('DOMContentLoaded', function () {
  const stickyContainer = document.querySelector('.sticky-add-to-cart-desktop');
  if (!stickyContainer) return;

  let stickyButton = stickyContainer.querySelector('[data-sticky-atc-desktop-button]');
  const stickyButtonContainer = stickyContainer.querySelector('[data-sticky-atc-desktop-button-container]');
  const stickyImage = stickyContainer.querySelector('[data-sticky-atc-desktop-image]');
  const stickyVariant = stickyContainer.querySelector('[data-sticky-atc-desktop-variant]');
  const stickyPrice = stickyContainer.querySelector('[data-sticky-atc-desktop-price]');

  // Same real-button-proxy pattern as the mobile bar (assets/sticky-cart.js): never
  // fork add-to-cart logic, just click the real button and inherit its fetch,
  // loading state, disabled state, and cart-drawer-open behavior for free.
  let mainButton = document.querySelector('form[action="/cart/add"] button');
  const cartDrawer = document.querySelector('cart-drawer');
  const productModal = document.querySelector('product-modal');
  const footer = document.getElementById('shopify-section-footer');

  // For PerksExclusive or subscription products: clone ONLY the button element
  // from the main form to avoid copying extra content (forms, callouts, etc.)
  const isSpecialProduct = stickyButtonContainer?.dataset.specialProduct === 'true';
  if (isSpecialProduct && stickyButtonContainer) {
    // For PerksExclusive (non-registered), look for the link inside <set-product-to-add-on-redirect>
    // For PerksExclusive (registered) or subscriptions, use the regular button
    let elementToClone = mainButton;
    const perksExclusiveLink = document.querySelector('set-product-to-add-on-redirect a.button');

    if (perksExclusiveLink) {
      elementToClone = perksExclusiveLink;
    } else if (!mainButton) {
      // If no button found, skip cloning
      console.warn('Sticky ATC: No button found to clone for special product');
      return;
    }

    // Clone only the button/link element (not its parent containers)
    const clonedButton = elementToClone.cloneNode(true);
    clonedButton.setAttribute('data-sticky-atc-desktop-button', '');
    clonedButton.classList.add('sticky-add-to-cart-desktop__button');

    // Remove IDs to avoid duplicates
    clonedButton.removeAttribute('id');
    const elementsWithId = clonedButton.querySelectorAll('[id]');
    elementsWithId.forEach((el) => el.removeAttribute('id'));

    // Clear existing content and append cloned button
    stickyButtonContainer.innerHTML = '';
    stickyButtonContainer.appendChild(clonedButton);

    // Update reference to the cloned button
    stickyButton = clonedButton;

    // Update mainButton reference for consistency
    if (!mainButton) mainButton = elementToClone;
  }

  if (stickyButton) {
    stickyButton.addEventListener('click', (e) => {
      // For cloned links (PerksExclusive "Sign Up to Purchase"), don't stop propagation
      // so the link navigation works naturally
      const isLink = stickyButton.tagName === 'A';
      if (!isLink) {
        e.stopPropagation();
      }

      // Analytics: Set atc-source cookie and publish sticky ATC click event
      document.cookie = 'atc-source=stickyATC; path=/; max-age=10';

      const clickData = {
        pageName: window.location.pathname,
        pageType: document.documentElement.dataset.pageType || 'product',
        moduleName: 'pdp:aplus:stickyAtc',
        linkTitle: 'Add to Cart',
        linkText: 'stickyAtcClick',
        targetURL: null,
        locURL: window.location.pathname,
        filters: null,
        searchTerm: null,
      };
      if (window.Shopify?.analytics?.publish) {
        window.Shopify.analytics.publish('page-click', { clickData });
      }

      // For special products (PerksExclusive/subscription), the button/link IS cloned,
      // so we don't need to click mainButton - it works naturally (button submits, link navigates).
      // For regular products, proxy click to the main button.
      if (!isSpecialProduct && !isLink) {
        mainButton?.click();
      }
    });
  }

  // Skip early return if we have a special product with a cloned button/link
  if (!mainButton && !isSpecialProduct) return;

  function updateFooterOffset() {
    const previewBar = document.getElementById('PBarNextFrameWrapper');

    const previewOffset = previewBar?.offsetHeight || 0;

    // Add/remove class based on preview bar presence to apply conditional styling
    if (previewBar && previewOffset > 0) {
      stickyContainer.classList.add('has-preview-bar');
    } else {
      stickyContainer.classList.remove('has-preview-bar');
    }

    if (!footer) {
      stickyContainer.style.setProperty('--sticky-offset', `${previewOffset}px`);
      return;
    }

    const footerRect = footer.getBoundingClientRect();
    const footerOverlap = Math.max(0, window.innerHeight - footerRect.top);

    stickyContainer.style.setProperty('--sticky-offset', `${footerOverlap + previewOffset}px`);
  }

  const observers = []; // For cleanup

  // Shopify injects the Preview Bar after page load in theme preview.
  // Observe DOM changes so the sticky offset is recalculated once it exists.
  const previewBarObserver = new MutationObserver(updateFooterOffset);

  previewBarObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });

  observers.push(previewBarObserver);

  // Track whether the user has scrolled past the main ATC at least once.
  // Prevents sticky ATC from showing on initial page load if main ATC is below the fold.
  let hasScrolledPastMainButton = false;

  // Returns true if mainButton is NOT visible in the viewport
  function isMainButtonOutOfView() {
    const rect = mainButton.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.bottom <= 0 || rect.top >= viewportHeight;
  }

  // Returns true if mainButton was visible and user scrolled past it (top is above viewport)
  function hasUserScrolledPast() {
    if (!mainButton) return false;
    const rect = mainButton.getBoundingClientRect();
    // Main button is considered "scrolled past" when its bottom edge goes above viewport top
    return rect.bottom <= 0;
  }

  // Returns true if footer is visible in viewport
  function isFooterVisible() {
    if (!footer) return false;
    const footerRect = footer.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    return footerRect.top < viewportHeight;
  }

  const updateVisibility = () => {
    // Track if user has scrolled past the main button
    if (hasUserScrolledPast()) {
      hasScrolledPastMainButton = true;
    } else if (!isMainButtonOutOfView()) {
      // Reset the flag when scrolling back to where main button is visible
      // This ensures sticky bar hides when user scrolls back to the first fold
      hasScrolledPastMainButton = false;
    }

    // Only show sticky ATC if:
    // 1. User has scrolled past the main ATC at least once (prevents showing on page load)
    // 2. Main ATC is currently out of view
    // 3. Footer is not visible
    const shouldShow = hasScrolledPastMainButton && isMainButtonOutOfView() && !isFooterVisible();
    stickyContainer.classList.toggle('show', shouldShow);
    stickyContainer.setAttribute('aria-hidden', !shouldShow);
    stickyButton.tabIndex = shouldShow ? 0 : -1;

    // Add padding to body when sticky is visible to prevent footer links from being covered
    // This pushes footer content up so it's visible above the sticky bar AND preview bar
    const stickyBarHeight = stickyContainer.offsetHeight || 93; // 9.3rem = 93px
    const previewBar = document.getElementById('PBarNextFrameWrapper');
    const previewBarHeight = previewBar?.offsetHeight || 0;
    const totalPadding = stickyBarHeight + previewBarHeight;

    if (shouldShow) {
      document.body.style.paddingBottom = `${totalPadding}px`;
    } else {
      document.body.style.paddingBottom = '';
    }
  };

  // Listen to scroll and resize to update sticky bar visibility
  window.addEventListener(
    'scroll',
    () => {
      updateFooterOffset();
      updateVisibility();
    },
    { passive: true },
  );

  window.addEventListener('resize', () => {
    updateFooterOffset();
    updateVisibility();
  });

  const updateOpenState = () => {
    const isDrawerActive = cartDrawer?.classList.contains('active');
    const isModalOpen = productModal?.hasAttribute('open');
    stickyContainer.style.display = isDrawerActive || isModalOpen ? 'none' : '';
  };

  if (cartDrawer) {
    const obs = new MutationObserver(updateOpenState);
    obs.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    observers.push(obs);
  }
  if (productModal) {
    const obs = new MutationObserver(updateOpenState);
    obs.observe(productModal, { attributes: true, attributeFilter: ['open'] });
    observers.push(obs);
  }

  const updateButtonState = () => {
    const span = mainButton.querySelector('span');
    if (!span || !stickyButton) return;

    // For special products, the button is already cloned and self-updating
    // (it's the actual form button). Skip manual sync to avoid conflicts.
    if (isSpecialProduct) return;

    stickyButton.disabled = mainButton.disabled;
    const stickySpan = stickyButton.querySelector('span');
    if (stickySpan) stickySpan.textContent = span.textContent;
  };

  // Only observe button state changes for regular products
  if (!isSpecialProduct) {
    const buttonObserver = new MutationObserver(updateButtonState);
    buttonObserver.observe(mainButton, {
      attributes: true,
      childList: true,
      subtree: true,
      characterData: true,
    });
    observers.push(buttonObserver);
    updateButtonState();
  }

  const withWidth = (url, width) => {
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}width=${width}`;
  };

  // eslint-disable-next-line no-undef
  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const variant = event?.data?.variant;
    if (!variant) return;

    const image = variant.featured_image?.src;
    if (stickyImage && image) {
      stickyImage.src = withWidth(image, 122);
      stickyImage.srcset = `${withWidth(image, 122)} 1x, ${withWidth(image, 244)} 2x`;
      stickyImage.alt = variant.featured_image.alt || '';
    }

    if (stickyVariant && Array.isArray(variant.options)) {
      // Don't display variant text if it's just "Default Title" or "Default"
      const hasRealVariants =
        variant.options.length > 1 ||
        (variant.options.length === 1 && variant.options[0] !== 'Default Title' && variant.options[0] !== 'Default');
      if (hasRealVariants) {
        // Display only option values, filtering out any "Default" or "Default Title" values
        const formatValue = (value) => {
          if (!value) return '';
          return value;
        };
        const filteredOptions = variant.options.filter((opt) => opt !== 'Default' && opt !== 'Default Title');
        stickyVariant.textContent = filteredOptions.map(formatValue).join(', ');
      } else {
        stickyVariant.textContent = '';
      }
    }

    // Price formatting/sale-strikethrough markup is intentionally not reimplemented
    // here -- clone it from the section HTML the theme already fetched for this
    // variant change, the same technique product-info.js uses for its own price
    // element, so formatting always matches the buy box exactly.
    const sourcePrice = event?.data?.html?.querySelector?.('[id^="price-"]');
    if (stickyPrice && sourcePrice) {
      stickyPrice.innerHTML = sourcePrice.innerHTML;
    }
  });

  // Cleanup MutationObservers on unload to prevent memory leaks
  window.addEventListener('beforeunload', () => observers.forEach((o) => o.disconnect()));

  // Initial visibility check on load - ensure sticky bar is hidden initially
  // The bar should only appear after scrolling past the first fold when inline CTA exits viewport
  stickyContainer.classList.remove('show');
  stickyContainer.setAttribute('aria-hidden', 'true');
  stickyButton.tabIndex = -1;
  updateFooterOffset();
});
